if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.touchStartX = 0;
        this.touchStartY = 0;

        this.horizontalSwipe = false;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);

        this.showActiveMedia();
        this.disableHorizontalSwipe();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );

        if (!activeMedia) return;

        const activeMediaTemplate =
          activeMedia.querySelector('template');

        const activeMediaContent =
          activeMediaTemplate
            ? activeMediaTemplate.content
            : null;

        activeMedia.classList.add('active');

        /*
         * Scroll vertically to the image
         * that the customer clicked.
         */
        activeMedia.scrollIntoView({
          block: 'start',
          inline: 'nearest'
        });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      disableHorizontalSwipe() {
        const container = this.querySelector(
          '.product-media-modal__content'
        );

        if (!container) return;

        if (
          container.dataset.horizontalSwipeDisabled === 'true'
        ) {
          return;
        }

        container.dataset.horizontalSwipeDisabled = 'true';

        /*
         * TOUCH START
         */
        container.addEventListener(
          'touchstart',
          (event) => {
            if (event.touches.length !== 1) return;

            this.touchStartX =
              event.touches[0].clientX;

            this.touchStartY =
              event.touches[0].clientY;

            this.horizontalSwipe = false;
          },
          {
            passive: true,
            capture: true
          }
        );

        /*
         * TOUCH MOVE
         *
         * Detect whether the gesture is mainly
         * horizontal or vertical.
         */
        container.addEventListener(
          'touchmove',
          (event) => {
            if (event.touches.length !== 1) return;

            const currentX =
              event.touches[0].clientX;

            const currentY =
              event.touches[0].clientY;

            const deltaX =
              currentX -
              this.touchStartX;

            const deltaY =
              currentY -
              this.touchStartY;

            const absX =
              Math.abs(deltaX);

            const absY =
              Math.abs(deltaY);

            /*
             * Horizontal swipe detected.
             */
            if (
              absX > 8 &&
              absX > absY
            ) {
              this.horizontalSwipe = true;

              event.preventDefault();

              /*
               * Critical:
               * prevent Dawn/Shopify swipe handlers
               * from receiving this gesture.
               */
              event.stopPropagation();

              event.stopImmediatePropagation();

              return;
            }

            /*
             * Vertical movement remains untouched,
             * so normal vertical scrolling works.
             */
            this.horizontalSwipe = false;
          },
          {
            passive: false,
            capture: true
          }
        );

        /*
         * TOUCH END
         *
         * Also intercept the release event.
         * Many slider scripts change the image
         * specifically on touchend.
         */
        container.addEventListener(
          'touchend',
          (event) => {
            if (!this.horizontalSwipe) return;

            event.preventDefault();

            event.stopPropagation();

            event.stopImmediatePropagation();

            this.horizontalSwipe = false;
          },
          {
            passive: false,
            capture: true
          }
        );

        /*
         * TOUCH CANCEL
         */
        container.addEventListener(
          'touchcancel',
          (event) => {
            if (this.horizontalSwipe) {
              event.stopPropagation();

              event.stopImmediatePropagation();
            }

            this.horizontalSwipe = false;
          },
          {
            passive: false,
            capture: true
          }
        );
      }
    }
  );
}